import { onboardingBcProtegeCheck } from '@portal/config/app.json';
import OnboardingApi from '@portal/repositories/onboarding';

export const isBcProtegeEnabledForThisPerson = async (
  taxId?: string
): Promise<boolean> => {
  if (!onboardingBcProtegeCheck) return false;
  if (!taxId) return true;

  try {
    const settings = await OnboardingApi.onboardingSettings();
    const limited = settings?.bcProtegeLimitedTaxIdentifiers;
    if (!limited) return true;
    return limited.includes(taxId);
  } catch {
    return true;
  }
};
